(function () {
  transformDoubleSlash();

  window.addEventListener("DOMContentLoaded", function () {
    transformDoubleSlash();
    addIconsToCart();
  });

  function addIconsToCart() {
    if (
      $("body").find("button[data-add-to-cart]").length &&
      !$("body").find("button[data-add-to-cart]").hasClass("iconAdded")
    ) {
      // $("body").find("button[data-add-to-cart]").addClass( "iconAdded" ).prepend('<i class="fa-solid fa-cart-plus"></i>')
    }

    if (
      $("body").find("button.shopify-payment-button__button").length &&
      !$("body")
        .find("button.shopify-payment-button__button")
        .hasClass("iconAdded")
    ) {
      // $("body").find("button.shopify-payment-button__button").addClass( "iconAdded" ).prepend('<i class="fa-solid fa-truck-fast"></i>')
    }
  }

  function transformDoubleSlash() {
    if (
      $("body").find(
        "h1.product-single__title, div.h4.product-card__title, div.list-view-item__title a"
      ).length
    ) {
      $(
        "h1.product-single__title, div.h4.product-card__title, div.list-view-item__title a"
      ).each(function (index, value) {
        if ($(value).text().split("//").length > 1) {
          var splitText = $(value).text().split("//");
          var firstPart = splitText.shift();
          var lastPart = splitText.join("//");

          var newText =
            firstPart + "<span class='notBold'>" + lastPart + "</span>";

          $(this).html(newText);
        }
      });
    }
  }
})();
